
const ScrollLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 30 30"
  >
    <rect
      width="30"
      height="30"
      fill="#F0F0F0"
      rx="15"
      transform="matrix(1 0 0 -1 0 30)"
    ></rect>
    <path
      stroke="#1777CF"
      strokeLinecap="square"
      strokeWidth="3"
      d="m11.543 21.6 6.914-6.864L11.543 8.4"
    ></path>
  </svg>
);

export default ScrollLeft;
